import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm } from "../../data/site";
import { CaseReviewForm } from "../form/CaseReviewForm";
type CaseReviewSectionProps = {
  showReviewNotes: boolean;
};
export function CaseReviewSection({
  showReviewNotes
}: CaseReviewSectionProps) {
  return <section aria-labelledby="case-review-title" className="border-t border-line bg-ivory" data-id="element-162" data-mp="32j5q7t27ypgs">
      <div className="page-container grid gap-8 py-12 md:py-16 lg:grid-cols-12 lg:gap-16" data-id="element-163" data-mp="3q8qacfa3zsrn">
        <div className="lg:col-span-5" data-id="element-164" data-mp="3v836jqmvec6w">
          <h2 id="case-review-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-165" data-mp="3v71m4vjysdci">
            Free case review
          </h2>
          <p className="mt-5 max-w-measure text-slate" data-id="element-166" data-mp="3ghm5i8e5doaj">
            Tell us about a Michigan motorcycle injury or a crash that took a loved one’s life. You can contact the firm for yourself or a family member.
          </p>
          <div className="mt-8 border-t border-line pt-6" data-id="element-167" data-mp="htygz3a2iu8o">
            <p className="text-meta font-semibold text-slate" data-id="element-168" data-mp="hvjbiswdud6j">Prefer to talk?</p>
            <a href={firm.phoneHref} className="mt-2 inline-flex min-h-[48px] items-center gap-3 text-phone font-extrabold text-ink hover:text-crimson" data-id="element-169" data-mp="3oekjysulc2o9">
              <PhoneIcon aria-hidden="true" className="h-7 w-7 text-crimson" data-id="element-170" data-mp="12jllkcbq1v3" />
              {firm.phoneDisplay}
            </a>
            <p className="mt-1 text-meta text-slate" data-id="element-171" data-mp="3sdjqghvz07ht">{firm.phoneDigits}</p>
          </div>
          <div className="mt-7 border-t border-line pt-6" data-id="element-172" data-mp="b195fins5wdz">
            <h3 className="text-h3 font-bold text-ink" data-id="element-173" data-mp="5z09cdfm2e7n">What happens next?</h3>
            <p className="mt-3 max-w-measure text-slate" data-id="element-174" data-mp="k0cpaouruftj">
              The review starts with the information you provide about the crash. The firm can discuss your questions and possible next steps.
            </p>
            <p className="mt-3 text-meta text-slate" data-id="element-175" data-mp="2lqftsi2ez3fs">There is no charge for the case review.</p>
          </div>
        </div>
        <div id="case-review" tabIndex={-1} className="scroll-mt-6 lg:col-span-7" data-id="element-176" data-mp="2hr6xb5fzorgj">
          <CaseReviewForm showReviewNotes={showReviewNotes} data-id="element-177" data-mp="kq1brjg6i5gc" />
        </div>
      </div>
    </section>;
}